import { env, clickSignWidgetUrl } from "../../env.ts"

export function Clicksign(i) {
  "use strict";
  function n(n) {
    let t;
    (e[(t = n).name || t] || []).forEach(function (t) {
      t(n.data);
    });
  }
  let o;
  let r;
  const t = window.location.protocol + "//" + window.location.host;
  var e = {};
  const u = function (t) {
    n(t.data);
  };
  return {
    endpoint: clickSignWidgetUrl[env.MODE],
    origin: t,
    mount: function (t) {
      const n = "/notarial/widget/signatures/" + i + "/redirect";
      var e = "?embedded=true&origin=" + this.origin;
      // eslint-disable-next-line no-redeclare
      var e = this.endpoint + n + e;
      return (
        (r = document.getElementById(t)),
        (o = document.createElement("iframe")).setAttribute("src", e),
        o.setAttribute("style", "width: 100%; height: 100%;"),
        o.setAttribute("allow", "camera"),
        window.addEventListener("message", u),
        r.appendChild(o)
      );
    },
    unmount: function () {
      return (
        o &&
        (r.removeChild(o),
          (o = r = null),
          window.removeEventListener("message", n)),
        !0
      );
    },
    on: function (t, n) {
      return e[t] || (e[t] = []), e[t].push(n);
    },
    trigger: n,
  };
}
